export default "__VITE_ASSET__BzbvZ4w2__"